import React from 'react';
import HardwareList from './HardwareList';
import "../../../assets/scss/hardware.scss";

const Hardware = () => <HardwareList />;

export default Hardware;